"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnterNormalString = exports.isEnterEmpty = exports.format = exports.formatValue = void 0;
var general_format_utils_1 = require("../general/general-format-utils");
var format_code_utils_1 = require("../format-code/format-code-utils");
// TODO: 向外暴露暂时不修改函数名称
var evaluate_format_1 = require("../core/evaluate-format");
// TODO: 暂时从原函数中引入, 待合入或补充进行修改
var FormatUtils_1 = require("../../utils/FormatUtils");
/**
 * 将给定数值按照单元格格式解析成对应数值, 为解析功能的入口函数
 * @param val 用户输入值
 * @param numberFormat 单元格数值格式
 * @param options 解析选项
 */
function formatValue(value, numberFormat, options) {
    var formatCode = FormatUtils_1.getFormatCodeByNumberFormat(numberFormat);
    var _a = format(formatCode, value, options), evaluatedValue = _a[0], evaluatedColor = _a[1];
    return {
        formatCode: formatCode,
        value: evaluatedValue,
        color: evaluatedColor,
    };
}
exports.formatValue = formatValue;
/**
 * 根据 格式串 格式化给定用户输入
 * @param format 原始格式化字符串
 * @param val 用户输入
 * @param options 其他选项
 */
function format(format, value, options) {
    var optionsCopy = __assign({}, options);
    var valueCopy = value;
    if (options === undefined || options === null) {
        optionsCopy = {};
    }
    // 判断格式未处理前是否为常规格式
    if (general_format_utils_1.isGeneral(format, 0)) {
        return [FormatUtils_1.general_fmt(valueCopy), null];
    }
    var _a = format_code_utils_1.choose_fmt(format, valueCopy), chosenFormatCode = _a.chosenFormatCode, formatListLength = _a.formatListLength;
    // 判断格式处理后是否为常规格式
    if (general_format_utils_1.isGeneral(chosenFormatCode)) {
        return [FormatUtils_1.general_fmt(valueCopy), null];
    }
    // 用户输入为空, 无格式
    if (isEnterEmpty(valueCopy)) {
        return ['', null];
    }
    // 判断内容为字符串, 格式非特殊文本格式, 无需解析直接返回
    if (typeof valueCopy === 'string' && isEnterNormalString(valueCopy, chosenFormatCode)) {
        return [valueCopy, null];
    }
    // 若为传入为布尔值
    if (typeof valueCopy === 'boolean') {
        valueCopy = String(valueCopy);
    }
    // 上述条件均不满足时, 进行对用户输入根据格式字符串进行解析
    return evaluate_format_1.eval_fmt(chosenFormatCode, valueCopy, formatListLength, optionsCopy);
}
exports.format = format;
/**
 * 判断输入是否为空值
 * @param input 传入输入值
 */
function isEnterEmpty(input) {
    // 为空字符串或 null
    if (input === '' || input === null) {
        return true;
    }
    // 为空白字符
    if (typeof input === 'string' && input.trim() === '') {
        return true;
    }
    return false;
}
exports.isEnterEmpty = isEnterEmpty;
/**
 * 判断输入是否为非特殊文本字符串
 * @param input 传入输入值
 */
function isEnterNormalString(input, formatCode) {
    // 数值类型字符串不属于文本字符串
    if (FormatUtils_1.checkNumericValue(input)) {
        return false;
    }
    // @, 格式串标识为文本格式
    // 如果还包含其他格式信息, 比如 _(@_), 则不是 NormalString
    return formatCode === '@';
}
exports.isEnterNormalString = isEnterNormalString;
//# sourceMappingURL=entry.js.map